import { Component, inject, ViewChild, HostListener } from '@angular/core';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule, NgIf } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ScriptService } from '../../services/script.service';
import { FormService } from '../../services/form.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { ValidationService } from '../../services/validation.service';
import { HttpService } from '../../services/http.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-add-script',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, FilterByKeyAndValuePipe, ModalComponent, TextInputComponent, ReactiveFormsModule, FormsModule, PluralPipe, SelectInputComponent, AgGridListComponent, BulkUploadComponent, SearchInputComponent, NgIf],
  templateUrl: './add-script.component.html',
  styleUrl: './add-script.component.css'
})
export class AddScriptComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  page_name = 'Script';
  form: FormGroup;
  params: any = {};
  script_images: any = [];
  selected_ids: any = {}
  items: any = [];
  assessment: any
  answerDirPatched: boolean = false;
  fs = inject(FormService);
  isFormInitializing: boolean = false;
  filter_university_id: any = '';
  filter_academic_year_id: any = '';
  filter_exam_id: any = '';
  filter_subject_id: any = '';
  link_copied: boolean = false;
  selected_rows: Set<number> = new Set();
  search_text: string = '';
  no_of_evaluation: number = 0;
  current_evaluation_level: number = 1;
  evaluator_columns: any[] = [];
  head_evaluator_columns: any[] = [];
  active_menu_id: any = null;
  pagination = { page: 1, page_size: 10 };
  total_pages = 1;
  supplement_start_index: number = 0;
  script_page_blur: number[] = [];
  supplement_page_blur: number[] = [];


  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { headerName: 'Date', field: 'document_uploaded_date', flex: 1 },
    { headerName: 'School', field: 'Assessment.University.name', flex: 1 },
    { headerName: 'Exam (Code)', field: 'Assessment.Exam.name', flex: 1 },
    { headerName: 'Subject', field: 'Assessment.Subject.name', flex: 1 },
    { headerName: 'Total Pages', field: 'ScriptImages.length', flex: 1 },
    { headerName: 'Barcode', field: 'barcode', flex: 1 },
    { headerName: 'L1 Code', field: '', flex: 1 },
    { headerName: 'L2 Code', field: '', flex: 1 },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'country_id', sample_value: 'India' },
    { column_name: 'State Name', type: 'text', return_as: 'state_id', sample_value: 'Maharashtra' },
    { column_name: 'Division Name', type: 'text', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'text', return_as: 'name', sample_value: 'Mumbai City' },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'Mumbai' },
  ];

  bulk_columns_download = [
    { column_name: 'Date', type: 'text', return_as: 'document_uploaded_date', sample_value: 'AD' },
    { column_name: 'Exam (Code)', download_bind: 'Assessment.Exam.id', type: 'link', linked_list: 'exam_list', linked_from: 'exam', return_as: 'exam_id', sample_value: 'AD' },
    { column_name: 'Subject', download_bind: 'Assessment.Subject.id', type: 'link', linked_list: 'subject_list', linked_from: 'subject', return_as: 'subject_id', sample_value: 'AD' },
    { column_name: 'Total Pages', type: 'text', return_as: 'ScriptImages.length', sample_value: '111' },
    { column_name: 'Barcode', type: 'text', return_as: 'barcode', sample_value: '111' },
    { column_name: 'L1 Code', type: 'text', return_as: '-', sample_value: '111' },
    { column_name: 'L2 Code', type: 'text', return_as: '-', sample_value: '111' },
  ]

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.script_management_scripts_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: (item: any) => this.route.navigate(['/add-script/form'], { queryParams: { id: item.id } }), permissions: this.gs.user_role_data?.script_management_scripts_update })
    if (row?.can_delete !== false && !row?.is_draft) actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this), permissions: this.gs.user_role_data?.script_management_scripts_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public script: ScriptService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService, public http: HttpService, public us: UserService) {
    this.form = this.fb.group({
      answer_script_directory: ['', [Validators.required]],
      no_of_pages_per_script: ['', [Validators.required, Validators.pattern(this.vs.code_pattern), Validators.min(1)]],
      hide_script_pages_for_faculty: ['', [Validators.required, Validators.pattern(this.vs.code_pattern)]],
      hide_script_percentage: ['', [Validators.required, Validators.pattern(/^[0-9%]*$/), Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/)]],
      no_of_pages_per_supplement: ['', [Validators.required]],
      hide_supplement_pages_for_faculty: ['', [Validators.required, Validators.pattern(/^[0-9%]*$/), Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/)]],
      hide_supplement_percentage: ['', [Validators.required, Validators.pattern(/^[0-9%]*$/), Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/)]],
      image_prefix: ['', [Validators.required]],
      image_format: ['', [Validators.required]],
      university_id: ['', [Validators.required]],

      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],

      academic_year_id: ['', [Validators.required]],
      exam_id: ['', [Validators.required]],
      subject_id: ['', [Validators.required]],
      is_active: [true],
      check: [true]
    });

    // Add custom validators for hide pages
    this.form.get('hide_script_pages_for_faculty')?.setValidators([
      Validators.required,
      Validators.pattern(this.vs.code_pattern),
      this.maxValueValidator('no_of_pages_per_script')
    ]);

    this.form.get('hide_supplement_pages_for_faculty')?.setValidators([
      Validators.required,
      Validators.pattern(/^[0-9%]*$/),
      Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/),
      this.maxValueValidator('no_of_pages_per_supplement')
    ]);

    // Update validators when base values change
    this.form.get('no_of_pages_per_script')?.valueChanges.subscribe(() => {
      this.form.get('hide_script_pages_for_faculty')?.updateValueAndValidity({ emitEvent: false });
    });

    this.form.get('no_of_pages_per_supplement')?.valueChanges.subscribe(() => {
      this.form.get('hide_supplement_pages_for_faculty')?.updateValueAndValidity({ emitEvent: false });
    });
  }
  async ngOnInit() {
    await this.dds?.get_dropdown_list(['exam', 'university', 'subject', 'academic-year', 'assessment', 'assess', 'evaluator']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params };
      if (params['university_id']) this.filter_university_id = params['university_id'];
      if (params['academic_year_id']) this.filter_academic_year_id = params['academic_year_id'];
      if (params['exam_id']) this.filter_exam_id = params['exam_id'];
      if (params['subject_id']) this.filter_subject_id = params['subject_id'];
      if (params['search'] !== undefined) this.search_text = params['search'] || '';
      await this.get_subject_users();
      await this.get_list();
    })
    this.form.valueChanges.subscribe(async values => {
      const { university_id, exam_id, subject_id, academic_year_id } = values;

      const university = this.dds.dropdown_list?.university_list?.find((x: any) => x.value == university_id);
      const academic_year = this.dds.dropdown_list?.academic_list?.find((x: any) => x.value == academic_year_id);
      const exam = this.dds.dropdown_list?.exam_list?.find((x: any) => x.value == exam_id);
      const subject = this.dds.dropdown_list?.subject_list?.find((x: any) => x.value == subject_id);
      const assessment = this.dds.dropdown_list?.assessment_list?.find((x: any) => x.exam_id == values.exam_id && x.university_id == values.university_id && x.subject_id == values.subject_id && x.academic_year_id == values.academic_year_id);

      console.log(assessment, 'rudra');
      if (assessment != undefined) {
        this.form.patchValue(
          { answer_script_directory: `${academic_year?.name}/${university?.code}/${assessment?.college?.code}/${assessment?.level?.code}/${assessment?.program?.code}/${assessment?.stream?.code}/${assessment?.exam?.code}/${assessment.subject?.code}` },
          { emitEvent: false },
        );
        // Mark that answer_script_directory was patched programmatically
        this.answerDirPatched = true;
        this.form.patchValue(
          { program_id: assessment?.program_id },
          { emitEvent: false },
        );
        this.form.patchValue(
          { level_id: assessment?.level_id },
          { emitEvent: false },
        );
        this.form.patchValue(
          { stream_id: assessment?.stream_id },
          { emitEvent: false },
        );
        this.form.patchValue(
          { college_id: assessment?.college_id },
          { emitEvent: false },
        );
        this.assessment = assessment
      } else {
        this.form.patchValue(
          { answer_script_directory: '' },
          { emitEvent: false }
        );
        this.answerDirPatched = false;
      }

    });
  }

  async create_directory() {
    if (!this.answerDirPatched) return;
    this.answerDirPatched = false;
    if (this.form.value.subject_id == null && this.form.value.exam_id == null && this.form.value.academic_year_id == null && this.form.value.university_id == null && this.form.value.assessment_id == null) return;
    if (!this.selected_ids.id) {
      await this.script.create_directory({ assessment_id: this.assessment.id });
    }
  }
  on_search(val: string) {
    this.search_text = val;
    this.pagination.page = 1;
    this.get_list();
  }

  async on_filter_change() {
    this.pagination.page = 1;
    this.sync_filters_to_url();
    await this.get_subject_users();
    await this.get_list();
  }

  async get_subject_users() {
    this.evaluator_columns = [];
    this.head_evaluator_columns = [];
  }

  sync_filters_to_url() {
    this.route.navigate([], {
      relativeTo: this.ar,
      queryParams: {
        university_id: this.filter_university_id || null,
        academic_year_id: this.filter_academic_year_id || null,
        exam_id: this.filter_exam_id || null,
        subject_id: this.filter_subject_id || null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  async on_university_filter_change(university_id: any) {
    this.filter_university_id = university_id;
    this.filter_academic_year_id = '';
    this.filter_exam_id = '';
    this.filter_subject_id = '';
    this.pagination.page = 1;
    this.sync_filters_to_url();
    await this.get_list();
  }

  async on_academic_year_filter_change() {
    this.filter_exam_id = '';
    this.filter_subject_id = '';
    this.pagination.page = 1;
    this.sync_filters_to_url();
    await this.get_list();
  }

  async on_exam_filter_change() {
    this.filter_subject_id = '';
    this.pagination.page = 1;
    this.sync_filters_to_url();
    await this.get_list();
  }

  toggle_row(id: number) {
    if (this.selected_rows.has(id)) this.selected_rows.delete(id);
    else this.selected_rows.add(id);
  }

  toggle_all(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) this.items?.data?.forEach((item: any) => this.selected_rows.add(item.id));
    else this.selected_rows.clear();
  }

  async get_list(filter?: any) {
    try {
      const backend_filter: any = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
        skip: (this.pagination.page - 1) * this.pagination.page_size,
        limit: this.pagination.page_size,
        ...(this.search_text ? { search: this.search_text } : {}),
        ...filter,
      };

      if (this.filter_university_id && this.filter_academic_year_id && this.filter_exam_id && this.filter_subject_id) {
        const assessment = this.dds.dropdown_list?.assessment_list?.find((x: any) =>
          x.university_id == this.filter_university_id &&
          x.academic_year_id == this.filter_academic_year_id &&
          x.exam_id == this.filter_exam_id &&
          x.subject_id == this.filter_subject_id
        );
        if (assessment) backend_filter['assessment_id'] = assessment.id;
      } else if (this.filter_university_id) {
        backend_filter['university_id'] = this.filter_university_id;
      }

      const res = await this.script.get_list(backend_filter);

      this.no_of_evaluation = (res as any).no_of_evaluation || 0;
      this.current_evaluation_level = (res as any).current_evaluation_level || 1;
      this.evaluator_columns = Array.from({ length: this.no_of_evaluation }, (_, i) => i + 1);
      this.head_evaluator_columns = (res as any).he_required ? [1] : [];

      const raw = res.data;
      let filtered: any[] = Array.isArray(raw) ? raw : (raw?.scripts || []);

      if (this.filter_academic_year_id) {
        filtered = filtered.filter((item: any) => item.Assessment?.AcademicYear?.id == this.filter_academic_year_id);
      }
      if (this.filter_exam_id) {
        filtered = filtered.filter((item: any) => item.Assessment?.Exam?.id == this.filter_exam_id);
      }
      if (this.filter_subject_id) {
        filtered = filtered.filter((item: any) => item.Assessment?.Subject?.id == this.filter_subject_id);
      }

      this.total_pages = Math.ceil((res.count || filtered.length) / this.pagination.page_size) || 1;
      this.items = { ...res, data: filtered, count: res.count || filtered.length };
    } catch (error: any) {
      console.error("Error fetching script list:", error);
    }
  }

  change_pagination(direction: string) {
    if (direction === 'next' && this.pagination.page < this.total_pages) {
      this.pagination.page++;
    } else if (direction === 'previous' && this.pagination.page > 1) {
      this.pagination.page--;
    } else if (direction === 'first') {
      this.pagination.page = 1;
    } else if (direction === 'last') {
      this.pagination.page = this.total_pages;
    }
    this.get_list();
  }

  async open_view_modal(item: any) {
    this.selected_ids = item || {};
    try {
      const response = await this.script.get(item.id);
      const data = response?.data;

      const sorted_images = (data?.ScriptImages || []).sort((a: any, b: any) => {
        const nameA = a.image_path?.split('/').pop() || '';
        const nameB = b.image_path?.split('/').pop() || '';
        return nameA.localeCompare(nameB);
      });

      this.script_images = sorted_images.map((img: any) =>
        this.http.base_url + '/media/get-file?file_path=scripts/' + img.image_path
      );

      this.apply_script_blur(data, this.script_images.length);
      this.view_modal?.open();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || 'Failed to load script', 'Error', 'error');
    }
  }

  apply_script_blur(script_data: any, image_count: number) {
    const no_of_pages_per_script = parseInt(script_data?.no_of_pages_per_script || '0');
    const no_of_pages_per_supplement = parseInt(script_data?.no_of_pages_per_supplement || '0');
    const hide_script_pages = parseInt(script_data?.hide_script_pages_for_faculty || '0');
    const hide_script_pct = parseInt(script_data?.hide_script_percentage || '0');
    const hide_supplement_pages = parseInt(script_data?.hide_supplement_pages_for_faculty || '0');
    const hide_supplement_pct = parseInt(script_data?.hide_supplement_percentage || '0');

    this.supplement_start_index = no_of_pages_per_script;
    this.script_page_blur = this.calculatePerPageBlur(hide_script_pages, hide_script_pct);

    const blur_per_group = this.calculatePerPageBlur(hide_supplement_pages, hide_supplement_pct);
    const total_supplement_pages = Math.max(0, image_count - no_of_pages_per_script);
    this.supplement_page_blur = [];
    if (no_of_pages_per_supplement > 0 && hide_supplement_pages > 0 && hide_supplement_pct > 0) {
      for (let i = 0; i < total_supplement_pages; i++) {
        const pos_in_group = i % no_of_pages_per_supplement;
        this.supplement_page_blur.push(blur_per_group[pos_in_group] ?? 0);
      }
    }
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete() {
    if (this.selected_rows.size > 0) {
      let all_success = true;
      for (const id of this.selected_rows) {
        const res = await this.script.delete(id);
        if (!res) all_success = false;
      }
      if (all_success) this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      this.selected_rows.clear();
    } else {
      const res = await this.script.delete(this.selected_ids.id);
      if (res) this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.selected_ids = {};
    }
    this.confirmation_delete_modal?.close();
    await this.get_list();
  }
  async disable_district() {
    try {
      let res = await this.script.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  open_bulk_delete_modal() {
    this.confirmation_delete_modal?.open();
  }

  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.script.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    await this.dds.refresh_dropdown_list(['subject', 'assess', 'assessment']);
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids?.id) {
      this.isFormInitializing = true;
      let response = await this.script.get(item.id);
      this.selected_ids = { ...response.data };

      // Patch dependent fields first with emitEvent: false
      this.form.patchValue({
        ...this.selected_ids,
        academic_year_id: this.selected_ids.Assessment?.AcademicYear?.id,
        university_id: this.selected_ids.Assessment?.University?.id,
        exam_id: this.selected_ids.Assessment?.Exam?.id,
        level_id: this.selected_ids.Assessment?.level_id,
        program_id: this.selected_ids.Assessment?.program_id,
        stream_id: this.selected_ids.Assessment?.stream_id,
        college_id: this.selected_ids.Assessment?.college_id,
      }, { emitEvent: false });

      // Then patch subject_id to ensure filtered options are properly loaded and trigger valueChanges
      setTimeout(() => {
        this.form.patchValue({
          subject_id: this.selected_ids?.Assessment?.Subject?.id,
        }, { emitEvent: true });
        this.isFormInitializing = false;
      }, 0);
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form.reset();
    this.form_modal?.close();
  }
  async submit(check: boolean) {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      form_value.check = check;
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.script.add(form_value);
        if (!check) this.gs.toastr_shows_function('Script Updated Successfully', 'Success', 'success');
      } else {
        let create_response = await this.script.add(form_value);
        if (!check) this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      if (check) {
        return;
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.script, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }

  // Custom validator to check if hide_pages is not greater than total pages
  maxValueValidator(compareControlName: string) {
    return (control: any) => {
      if (!control.value || !this.form) {
        return null;
      }

      const compareControl = this.form.get(compareControlName);
      if (!compareControl || !compareControl.value) {
        return null;
      }

      const currentValue = parseInt(control.value);
      const maxValue = parseInt(compareControl.value);

      if (isNaN(currentValue) || isNaN(maxValue)) {
        return null;
      }

      if (currentValue > maxValue) {
        return {
          maxValue: {
            max: maxValue,
            actual: currentValue,
            message: `Cannot be greater than ${maxValue}`
          }
        };
      }

      return null;
    };
  }
  get_evaluators(item: any): any[] {
    const evaluator_ids = new Set(this.evaluator_columns.map((u: any) => u.id));
    return (item.Evaluations || []).filter((e: any) =>
      evaluator_ids.has(e.user_id) || evaluator_ids.has(e.User?.id)
    );
  }

  get_head_evaluators(item: any): any[] {
    const head_ids = new Set(this.head_evaluator_columns.map((u: any) => u.id));
    const from_evaluations = (item.Evaluations || []).filter((e: any) =>
      head_ids.has(e.user_id) || head_ids.has(e.User?.id)
    );
    if (from_evaluations.length > 0) return from_evaluations;
    if (item.HeadEvaluation) return [item.HeadEvaluation];
    return [];
  }

  is_last_level_completed(item: any): boolean {
    return (item.Evaluations || []).some((e: any) => e.level == this.no_of_evaluation && e.status === 'Completed');
  }

  @HostListener('document:click')
  close_menu() { this.active_menu_id = null; }

  toggle_menu(id: any, event: Event) {
    event.stopPropagation();
    this.active_menu_id = this.active_menu_id === id ? null : id;
  }

  get can_add_script(): boolean {
    return this.current_evaluation_level === 1;
  }

  format_date(dt: string | null | undefined): string {
    if (!dt) return '-';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return dt;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  async download_scripts() {
    try {
      const backend_filter: any = { page_size: 9999999, download: true };

      if (this.filter_university_id && this.filter_academic_year_id && this.filter_exam_id && this.filter_subject_id) {
        const assessment = this.dds.dropdown_list?.assessment_list?.find((x: any) =>
          x.university_id == this.filter_university_id &&
          x.academic_year_id == this.filter_academic_year_id &&
          x.exam_id == this.filter_exam_id &&
          x.subject_id == this.filter_subject_id
        );
        if (assessment) backend_filter['assessment_id'] = assessment.id;
      } else if (this.filter_university_id) {
        backend_filter['university_id'] = this.filter_university_id;
      }

      const res = await this.script.get_list(backend_filter);
      let scripts: any[] = Array.isArray(res.data) ? res.data : (res.data?.scripts || []);

      if (this.filter_academic_year_id) scripts = scripts.filter((s: any) => s.Assessment?.AcademicYear?.id == this.filter_academic_year_id);
      if (this.filter_exam_id) scripts = scripts.filter((s: any) => s.Assessment?.Exam?.id == this.filter_exam_id);
      if (this.filter_subject_id) scripts = scripts.filter((s: any) => s.Assessment?.Subject?.id == this.filter_subject_id);

      if (!scripts.length) {
        this.gs.toastr_shows_function('No data available to download', 'Info', 'info');
        return;
      }

      const num_evaluators = Math.max(1, ...scripts.map((s: any) => Number(s.Assessment?.no_of_evaluation) || 0));
      const he_required = scripts.some((s: any) => s.Assessment?.head_examiner_required);

      const headers: string[] = [
        'Subject Name (Code)', 'Scanned Date', 'AI Status', 'Total Pages',
        'No. of Supplements', 'Barcode',
      ];
      for (let i = 1; i <= num_evaluators; i++) {
        headers.push(`Evaluator ${i}`);
        headers.push(`Date of Evaluation ${i}`);
      }
      if (he_required) {
        headers.push('Head Evaluator');
        headers.push('Head Evaluation Date');
      }
      headers.push('Status');

      const rows = scripts.map((s: any) => {
        const subject_name = s.Assessment?.Subject?.name || '';
        const subject_code = s.Assessment?.Subject?.code || '';
        const subject_col = subject_code ? `${subject_name} (${subject_code})` : subject_name;

        const scanned_date = s.document_uploaded_date
          ? (() => { const d = new Date(s.document_uploaded_date); return isNaN(d.getTime()) ? s.document_uploaded_date : `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`; })()
          : '-';

        const ai_status = s?.ai_status || s.ai_job_status || s.Assessment?.ai_job_status || '-';
        const total_pages = s.ScriptImages?.length ?? s.no_of_pages_per_script ?? '-';
        const supplements = s.no_of_pages_per_supplement ?? '-';
        const is_completed = (s.Evaluations || []).some((e: any) => e.level == num_evaluators && e.status === 'Completed');
        const status = is_completed ? 'Completed' : 'Pending';

        const row: any[] = [subject_col, scanned_date, ai_status, total_pages, supplements, s.barcode || '-'];

        for (let i = 1; i <= num_evaluators; i++) {
          const ev = s[`evaluator_${i}`];
          row.push(ev?.name || '-');
          row.push(this.format_date(ev?.evaluated_at));
        }
        if (he_required) {
          const he = s.head_evaluator;
          row.push(he?.name || '-');
          row.push(this.format_date(he?.evaluated_at));
        }
        row.push(status);
        return row;
      });

      const csv = [headers, ...rows]
        .map(row => row.map((cell: any) => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','))
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'scripts.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || 'Download failed', 'Error', 'error');
    }
  }

  calculatePerPageBlur(pages: number, percentage: number): number[] {
    if (pages <= 0 || percentage <= 0) return [];
    const totalCoverage = pages * (percentage / 100);
    const result: number[] = [];
    let remaining = totalCoverage;
    for (let i = 0; i < pages; i++) {
      if (remaining >= 1) {
        result.push(100);
        remaining -= 1;
      } else if (remaining > 0) {
        result.push(Math.round(remaining * 100));
        remaining = 0;
      } else {
        result.push(0);
      }
    }
    return result;
  }

  change_hide_supplement_percentage_value() {
    if (this.form.value.hide_supplement_pages_for_faculty == 0 || this.form.value.hide_supplement_pages_for_faculty == '0') {
      this.form.patchValue({ hide_supplement_percentage: 0 });
    }
  }

  copy_directory() {
    const dir = this.form.get('answer_script_directory')?.value;
    if (dir) {
      navigator.clipboard.writeText(dir);
      this.link_copied = true;
      setTimeout(() => { this.link_copied = false; }, 2000);
    }
  }

  isFormatSelected(format: string): boolean {
    const formats: string[] = this.form.get('image_format')?.value || [];
    return Array.isArray(formats) && formats.includes(format);
  }

  toggleImageFormat(format: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    let formats: string[] = Array.isArray(this.form.get('image_format')?.value)
      ? [...this.form.get('image_format')?.value]
      : [];
    if (checked) {
      if (!formats.includes(format)) formats.push(format);
    } else {
      formats = formats.filter(f => f !== format);
    }
    this.form.patchValue({ image_format: formats });
  }
}

